// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidSterilization from '../_raw/service/icon_covid_sterilization.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidSterilization);
